import { SCHEME_TYPE_IDS_FOR_AGEING_DAYS_SELECTION, SCHEME_TYPE_IDS_FOR_DEALER_REMAINING_LIMIT, SCHEME_TYPE_IDS_FOR_THRESHOLD_GMV_SELECTION } from "../../../config/constant";

const formValidation = (data,t) => { 
    let formIsValid = true;
    let tempErrors = {}; 
    
    if (!data["product_type"]) {
        formIsValid = false;
        tempErrors["product_type"] = t('VALIDATION.PRODUCT_TYPE');
    }
    if (!data["scheme_duration"]) {
        formIsValid = false;
        tempErrors["scheme_duration"] = t('VALIDATION.SCHEME_DURATION');
    }
    if (!data["applicable_to"]) {
        formIsValid = false;
        tempErrors["applicable_to"] = t('VALIDATION.APPLICATION_TO');
    }
    if (SCHEME_TYPE_IDS_FOR_AGEING_DAYS_SELECTION.includes(data.scheme_type_id) && !data["ageing_days"]) {
        formIsValid = false;
        tempErrors["ageing_days"] = t('VALIDATION.AGEING_DAYS');
    }
    if (SCHEME_TYPE_IDS_FOR_THRESHOLD_GMV_SELECTION.includes(data.scheme_type_id) && !data["threshold_gmv"]) {
        formIsValid = false;
        tempErrors["threshold_gmv"] = t("VALIDATION.THRESHOLD_GMV");
    }
    if (SCHEME_TYPE_IDS_FOR_DEALER_REMAINING_LIMIT.includes(data.scheme_type_id) && !data["dealer_remaining_limit"]) {
        formIsValid = false;
        tempErrors["dealer_remaining_limit"] = t("VALIDATION.DEALER_REMAINING_LIMIT");
    }
    if (data.form_config.AUM_EXIT){
        data[data.form_config.KEY].forEach((element, index) => {
            if (element.min_disb_per === "") {
                formIsValid = false;
                tempErrors["min_disb_per_" + index] = t('IF.VALIDATION.MIN_DISB_ACH');
            }
            if (element.max_disb_per === "") {
                formIsValid = false;
                tempErrors["max_disb_per_" + index] = t('IF.VALIDATION.MAX_DISB_ACH');
            }
            if (element.incentive_amount === "") {
                formIsValid = false;
                tempErrors["incentive_amount_" + index] = t('IF.VALIDATION.INC_AMT');
            }
            
        });
    }
    if (data.form_config.FRESH_GMV){
        data[data.form_config.KEY].forEach((element, index) => {
            if (element.min_disb_per === "") {
                formIsValid = false;
                tempErrors["min_disb_per_" + index] = t('IF.VALIDATION.MIN_DISB_ACH');
            }
            if (element.max_disb_per === "") {
                formIsValid = false;
                tempErrors["max_disb_per_" + index] = t('IF.VALIDATION.MAX_DISB_ACH');
            }
            if (element.incentive_amount === "") {
                formIsValid = false;
                tempErrors["incentive_amount_" + index] = t('IF.VALIDATION.INC_AMT');
            }
            if (!element.incentive_amount_usd) {
                formIsValid = false;
                tempErrors["incentive_amount_usd_" + index] = t('IF.VALIDATION.INC_AMT_USD');
            }
            
        });
    }
    if (data.form_config.ACTIVATION){
        data[data.form_config.KEY].forEach((element, index) => {
            if (!element.min_disb_per) {
                formIsValid = false;
                tempErrors["min_disb_per_" + index] = t("IF.VALIDATION.MIN_ACTIVATION");
            }
            if (!element.max_disb_per) {
                formIsValid = false;
                tempErrors["max_disb_per_" + index] = t("IF.VALIDATION.MAX_ACTIVATION");
            }
            if (!element.incentive_amount) {
                formIsValid = false;
                tempErrors["incentive_amount_" + index] = t('IF.VALIDATION.INC_AMT');
            }
            
        });
    }
    if (data.form_config.NCL){
        data[data.form_config.KEY].forEach((element, index) => {
            if (!element.min_disb_per && !element.max_disb_per) {
                formIsValid = false;
                tempErrors["min_disb_per_" + index] = t('IF.VALIDATION.MIN_NCL');
                tempErrors["max_disb_per_" + index] = t('IF.VALIDATION.MAX_NCL');
            }
            if (!element.incentive_amount) {
                formIsValid = false;
                tempErrors["incentive_amount_" + index] = t('IF.VALIDATION.REMOVAL_PERCENT');
            } else if (Number(element.incentive_amount) > 100) {
                formIsValid = false;
                tempErrors["incentive_amount_" + index] = t('IF.VALIDATION.REMOVAL_PERCENT_GREATER_THAN_100')
            }
        });
    }

    if (data.sub_schemes && data.sub_schemes.length > 0) {
        const subSchemes = data.sub_schemes;

        if (subSchemes.length > 1) {
            const firstReductionCount = subSchemes.filter((scheme) => scheme.first_reduction).length;

            if (firstReductionCount !== 1) {
                formIsValid = false;
                subSchemes?.forEach(subScheme => {
                    tempErrors["first_reduction_" + subScheme.sub_scheme_type_id + "_" + (data.id || data.temp_id)] = t("IF.VALIDATION.FIRST_REDUCTION");
                })
            }
        }

        subSchemes.forEach((subScheme, sIndex) => {
            subScheme.sub_scheme_details?.forEach((row, rIndex) => {
                if (!row.min_value && !row.max_value) {
                    formIsValid = false;
                    tempErrors[`min_value_${subScheme.sub_scheme_type_id}_${rIndex}`] = t("IF.VALIDATION.SUB_SCHEME_DETAILS_EMPTY");
                    tempErrors[`max_value_${subScheme.sub_scheme_type_id}_${rIndex}`] = t("IF.VALIDATION.SUB_SCHEME_DETAILS_EMPTY");
                }
                if (!row.incentive_percent) {
                    formIsValid = false;
                    tempErrors[`incentive_percent_${subScheme.sub_scheme_type_id}_${rIndex}`] = t(
                        "IF.VALIDATION.INCENTIVE_PERCENT"
                    );
                }
                if (row.min_value && row.max_value && Number(row.min_value) > Number(row.max_value)) {
                    formIsValid = false;
                    tempErrors[`min_value_${subScheme.sub_scheme_type_id}_${rIndex}`] = t("IF.VALIDATION.SUB_SCHEME_MIN_MAX");
                    tempErrors[`max_value_${subScheme.sub_scheme_type_id}_${rIndex}`] = t("IF.VALIDATION.SUB_SCHEME_MIN_MAX");
                }
            });
        });
    }

    return {tempErrors, formIsValid};
};




export default formValidation;